import { jsx as _jsx } from "react/jsx-runtime";
import { CurrentPatientProvider, Modal, PatientDataModalForm, useShowToast, } from "@madmedical/ui";
import { ApiFormWrapper } from "@madmedical/form";
import { invariant } from "@madmedical/utils";
import { useUpdatePatientMutation } from "../api";
import usePatient from "../usePatient";
const EditPatientDetailsModal = ({ open, onClose }) => {
    const { patient, refetch } = usePatient();
    const [updatePatient] = useUpdatePatientMutation();
    const showToast = useShowToast();
    const handleSuccess = () => {
        showToast("Mentés sikeres.", { variant: "success" });
        void refetch();
    };
    if (!patient) {
        return null;
    }
    invariant("underlyingConditions" in patient);
    return (_jsx(Modal, Object.assign({ open: open, onClose: onClose, size: "sm" }, { children: _jsx(CurrentPatientProvider, Object.assign({ value: { patient: patient } }, { children: _jsx(ApiFormWrapper, Object.assign({ defaultValues: {
                    id: patient.userId,
                    underlyingConditions: patient.underlyingConditions,
                }, mutation: updatePatient, onSuccess: handleSuccess }, { children: ({ submitForm, isSuccess }) => (_jsx(PatientDataModalForm, { onClose: onClose, onSubmitPress: submitForm, isSuccess: isSuccess })) })) })) })));
};
export default EditPatientDetailsModal;
